<a
	class="
		category-bubble-link
		hmf-align-items-center
		hmf-body-m
		hmf-body-xlg-l
		hmf-display-flex
		hmf-flex-column
		hmf-p-xxs
		hmf-text-align-center"
	href="{{link()}}"
	>
	<img
		class="bubble-image"
		alt="{{altText()}}"
		[src]="image()"
		loading="lazy"
	/>
	<span class="bubble-label hmf-pt-xxs hmf-pb-xxxs">
		{{ label() }}
	</span>
</a>
